import { DOCUMENT } from '@angular/common';
import { Injectable, inject } from '@angular/core';
import { environment } from '../../../environments/environment';

declare global {
  interface Window {
    OptanonWrapper?: () => void;
    OneTrust?: {
      ToggleInfoDisplay?: () => void;
    };
  }
}

@Injectable({ providedIn: 'root' })
export class CookieConsentService {
  private readonly document = inject(DOCUMENT);
  private readonly config = environment.cookieConsent;
  private readonly scriptId = 'onetrust-sdk';

  load(): void {
    if (!this.config.enabled || !this.config.domainScriptId || !this.document.defaultView) {
      return;
    }

    const windowRef = this.document.defaultView;
    windowRef.OptanonWrapper ??= () => undefined;

    if (this.document.getElementById(this.scriptId)) {
      return;
    }

    const script = this.document.createElement('script');
    script.id = this.scriptId;
    script.src = this.config.scriptUrl;
    script.type = 'text/javascript';
    script.charset = 'UTF-8';
    script.dataset['documentLanguage'] = 'true';
    script.dataset['domainScript'] = this.config.domainScriptId;

    this.document.head.appendChild(script);
  }

  openPreferenceCenter(): void {
    this.document.defaultView?.OneTrust?.ToggleInfoDisplay?.();
  }

  get isEnabled(): boolean {
    return this.config.enabled;
  }
}